import * as React from 'react'

function SvgPaymentIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.2 4.38l-1.942 7.245a1 1 0 00.708 1.225l.653.175m.58-8.644l.648-2.415a1 1 0 011.224-.707l16.421 4.4a1 1 0 01.707 1.224l-.647 2.415M3.2 4.381L16 7.81m5.552 1.487l-.841 3.14m.841-3.14L20 8.882"
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinejoin="round"
      />
      <rect
        x={2}
        y={11.659}
        width={18}
        height={12}
        rx={1}
        transform="rotate(-15 2 11.659)"
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinejoin="round"
      />
      <circle
        cx={7.511}
        cy={14.841}
        r={1.5}
        transform="rotate(-15 7.511 14.84)"
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinejoin="round"
      />
      <circle
        cx={10.409}
        cy={14.064}
        r={1.5}
        transform="rotate(-15 10.41 14.064)"
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgPaymentIcon
